// extracted by mini-css-extract-plugin
export default {"footerButton":"_20SNn","iconContainer":"_1EIXP","iconSuccess":"_2Ufo4","success-icon":"_3_EYc"};